import {Component, inject, OnInit, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {GetConfigFacade} from '@features/app-config/presentation/facades/get-config/get-config.facade';
import {SpinnerGlobal} from '@ui/SpinnersModule/components/spinner-global/spinner-global';
import {Toast} from '@ui/ToastModule/components/toast/toast';
import {ThemePort} from '@shared/application/ports/theme/theme.port';
import {VerifyAuthFacadeProvider} from '@features/auth/presentation/facades/verify-auth/verify-auth.facade.provider';
import {ModalSwalComponent} from '@ui/ModalsModule/components/modal-swal/modal-swal';
import {ListAgreementFacade} from '@features/agreement/presentation/facades/list-agreement/list-agreement.facade';
import {
  ListAgreementFacadeProvider
} from '@features/agreement/presentation/facades/list-agreement/list-agreement.facade.provider';
import {
  ListProductFacadeProvider
} from '@features/product/presentation/facades/list-product/list-product.facade.provider';
import {ListProductFacade} from '@features/product/presentation/facades/list-product/list-product.facade';
import {
  ListDocumentTypesFacadeProvider
} from '@features/setting/presentation/facades/list-document-types/list-document-types.facade.provider';
import {
  ListPersonTypesFacadeProvider
} from '@features/setting/presentation/facades/list-person-types/list-person-types.facade.provider';
import {ListPersonTypesFacade} from '@features/setting/presentation/facades/list-person-types/list-person-types.facade';
import {
  ListDocumentTypesFacade
} from '@features/setting/presentation/facades/list-document-types/list-document-types.facade';
import {ListCitiesFacade} from '@features/setting/presentation/facades/list-cities/list-cities.facade';
import {ListCitiesFacadeProvider} from '@features/setting/presentation/facades/list-cities/list-cities.facade.provider';
import {
  MyHistoryCreditFacadeProvider
} from '@features/credit/presentation/facades/my-history-credit/my-history-credit.facade.provider';
import {
  MyCustomerDataFacadeProvider
} from '@features/customer/presentation/facades/my-customer-data/my-customer-data.facade.provider';
import {FileContextProvider} from '@shared/infrastructure/context/file-context.provider';
import {ListBanksFacadeProvider} from '@features/setting/presentation/facades/list-banks/list-banks.facade.provider';
import {
  GetUsuryRateFacadeProvider
} from '@features/setting/presentation/facades/get-usury-rate/get-usury-rate.facade.provider';
import {GetUsuryRateFacade} from '@features/setting/presentation/facades/get-usury-rate/get-usury-rate.facade';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerGlobal, Toast, ModalSwalComponent],
  templateUrl: './app.html',
  styles: `
    :host {
      display: inherit;
    }
  `,
  providers: [
    ...VerifyAuthFacadeProvider,
    ...ListAgreementFacadeProvider,
    ...ListProductFacadeProvider,
    ...ListDocumentTypesFacadeProvider,
    ...ListPersonTypesFacadeProvider,
    ...ListCitiesFacadeProvider,
    ...VerifyAuthFacadeProvider,
    ...MyHistoryCreditFacadeProvider,
    ...MyCustomerDataFacadeProvider,
    ...FileContextProvider,
    ...ListBanksFacadeProvider,
    ...GetUsuryRateFacadeProvider,
  ]
})
export class App implements OnInit {

  protected readonly title = signal('Cargando...');

  public facadeGetConfig: GetConfigFacade = inject(GetConfigFacade);
  public listAgreementFacade: ListAgreementFacade = inject(ListAgreementFacade);
  public listPersonTypesFacade: ListPersonTypesFacade = inject(ListPersonTypesFacade);
  public listDocumentTypesFacade: ListDocumentTypesFacade = inject(ListDocumentTypesFacade);
  public listProductFacade: ListProductFacade = inject(ListProductFacade);
  public listCitiesFacade: ListCitiesFacade = inject(ListCitiesFacade);
  public getUsuryRateFacade: GetUsuryRateFacade = inject(GetUsuryRateFacade);
  public themePort: ThemePort = inject(ThemePort);

  ngOnInit() {
    this.facadeGetConfig.load({});
    this.listAgreementFacade.load({config: []});
    this.listProductFacade.load({config: []});
    this.listPersonTypesFacade.load({});
    this.listDocumentTypesFacade.load({});
    this.listCitiesFacade.load({});
    this.getUsuryRateFacade.load({});
  }

}
